export default __webpack_public_path__ + "static/media/kyllikkiscrypt.a24779c3.jpg";